// extracted by mini-css-extract-plugin
module.exports = {"container":"GameDetailSpecList_container___2ipG"};